import { imprimirRelatorioCaixa } from 'modulo-gerencial-erp-pacotes-impressora-termica';

import { imprimirServicoNovo, buscarDadosImpressao } from '../utils';

async function imprimir(id, query = '', usar_nova_impressao = false) {
  /* if (!usar_nova_impressao) {
    return await imprimirServicoAntigo(id, 3, query);
  }

  const dados = await buscarDadosImpressao(id, 3);

  const { comandos } = layout(adapter(dados));

  const response = await imprimirServicoNovo(id, 'relatorio-sessao', comandos);
  return response.data; */

  return await imprimirRelatorioCaixa({
    id,
    buscarDadosImpressao,
    chamarServicoImpressoraTermica: imprimirServicoNovo,
    query: '',
  });
}

export default imprimir;
